<template>
    <div class="section-container">
        <div class="row justify-content-center">
            <div class="col-10">
                <section class="content-block">
                    <header class="header">What is Hangmans?</header>
                    <p>
                        Hangman wss originally a paper and pencil guessing game for two or more players. 
                        One player thinks of a word, phrase or sentence and the other(s) tries to guess it by suggesting letters or numbers, within a certain number of guesses.
                    </p>
                </section>
                <section class="content-block">
                    <header class="header">How to play?</header>
                    <p>
                        Pick a game, and start guessing letters and ultimately, try to figure out the word.
                        It's that simple!
                    </p>
                    <p>
                        Please note, that you cannot play yourself. Your transaction will fail if you try. 
                    </p>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Rules'
}
</script>

<style scoped lang="less">
@import "../assets/less/generic.less";

.section-container {
    padding-top: 130px;
}
</style>


// WEBPACK FOOTER //
// src/views/Rules.vue